import { Popover, PopoverContent, PopoverTrigger, Portal } from '@chakra-ui/react';
import { DeleteIcon } from '@sketchnote/icons';
import { PlateRenderElementProps, unwrapNodes, useEditorRef, Value } from '@udecode/plate';
import cn from 'classnames';
import * as React from 'react';
import { ReactEditor } from 'slate-react';
import { useReadOnly } from 'slate-react';

import { ELEMENT_LEGAL_PH } from '../legal-ph';

const { useCallback, Fragment } = React;

type ElementProps<TElement = { filled: boolean }> = PlateRenderElementProps<Value> & TElement;

// Element of Legal editor's placeholder
export const LegalPhElement = ({ attributes, children, element }: ElementProps): JSX.Element => {
  const editor = useEditorRef();
  const isReadOnly = useReadOnly();
  const handleMouseDown = useCallback((event) => {
    event.preventDefault();
    unwrapNodes(editor, {
      at: ReactEditor.findPath(editor, element),
      match: { type: ELEMENT_LEGAL_PH },
    });
  }, []);

  return (
    <Fragment>
      {!isReadOnly ? (
        <Popover placement="bottom" trigger="hover">
          <PopoverTrigger>
            <span
              {...attributes}
              className={cn('rounded underline', {
                'bg-green-100': element.filled,
                'bg-yellow-100': !element.filled,
              })}
            >
              {children}
            </span>
          </PopoverTrigger>
          {process.env.NODE_ENV === 'development' ? (
            <Portal>
              <PopoverContent>
                <div className="shadow-md flex bg-white justify-between">
                  <button className="p-5" onMouseDown={handleMouseDown}>
                    <DeleteIcon />
                  </button>
                </div>
              </PopoverContent>
            </Portal>
          ) : null}
        </Popover>
      ) : (
        <span
          {...attributes}
          className={cn('rounded underline', {
            'bg-green-100': element.filled,
            'bg-yellow-100': !element.filled,
          })}
        >
          {children}
        </span>
      )}
    </Fragment>
  );
};
